export default __webpack_public_path__ + "static/media/pdaLight.5b951a88.svg";